import { useLocation, Navigate } from 'react-router-dom';

function TrailingSlashRedirect() {
  const location = useLocation();

  if (location.pathname !== '/' && location.pathname.endsWith('/')) {
    return (
      <Navigate
        to={location.pathname.replace(/\/+$/, '') + location.search + location.hash}
        replace
      />
    );
  }

  return null;
}

export default TrailingSlashRedirect;
